import MediaQuery from 'react-responsive'

import DownloadApp from 'shared/components/DownloadApp'
import SpecialOffers from 'shared/components/SpecialOffers'
import { GRID_BREAKPOINT_SM, GRID_BREAKPOINT_MD } from 'shared/breakpoints'

import FindAndBook from './FindAndBook'
import WhyChoose from './WhyChoose'
import Offers from './Offers'
import Services from './Services'
import Career from './Career'
import Corporate from './Corporate'
import Subscribe from './Subscribe'
import Partners from './Partners'

const HomeView = () => (
    <div className="home-container">
        <FindAndBook />
        <SpecialOffers />
        <WhyChoose />
        <Offers />

        <MediaQuery maxWidth={GRID_BREAKPOINT_SM - 1}>
            <Services itemsPerSlide={2} />
        </MediaQuery>
        <MediaQuery minWidth={GRID_BREAKPOINT_SM} maxWidth={GRID_BREAKPOINT_MD - 1}>
            <Services itemsPerSlide={3} />
        </MediaQuery>
        <MediaQuery minWidth={GRID_BREAKPOINT_MD}>
            <Services itemsPerSlide={5} />
        </MediaQuery>
        <Partners />
        <Corporate />
        <Subscribe />
        <Career />
        <DownloadApp />
    </div>
)

export default HomeView
